<template>
  <div class=""></div>
</template>

<script>
export default {
  components: { Flipbook },
  data() {
    return {
      a: "",
    };
  },
};
</script>
